
<template>
   <div class="container">
   
   <h4 style="margin-top: 20%;" v-text="_trans('')">ERROR! Missing Component:</h4>
   <hr/>
   <h1 class="mt-4 center" style="color:red; font-weight:900">{{params}}</h1>
   <hr/>
   </div>
</template>

<script>
export default {
  props:{
      params:String
  },
}
</script>



// WEBPACK FOOTER //
// src/_eng/globals/dzmissing.vue